import { gql } from '@apollo/client';
import { VENUE_FRAGMENT } from './Venue';

export const UserDataQuery = gql`
  query UserDataQuery($locationId: ID) {
    user(locationId: $locationId) {
      id
      givenName
      familyName
      venues {
        ...VenueFragment
      }
      permissions
    }
    dietaryEnums
  }
  ${VENUE_FRAGMENT}
`;
